import React from 'react';
import { useFormContext } from 'react-hook-form';


const FormInput = ({ name, label, spanText, disabled, type = 'text', options = [], registerOptions = {}, ...rest }) => {
  const { register, formState: { errors }, getValues } = useFormContext();

  const inputClass = errors[name]
    ? 'form-input form-error'
    : (getValues(name) ? 'form-input form-valid' : 'form-input form-default');

    const spanStyle = {
      fontSize: '12px',
      color: 'gray',
      display: 'block',
    };

  const isRequired = registerOptions?.required;

  return (
    <div className="form-group">
      <label className="form-label">
        {label}{isRequired && <span className="required-asterisk">*</span>}
      </label>
      {options.length ? (
        <select
          className={inputClass}
          {...register(name, registerOptions)}
          {...rest}
          disabled = {disabled }
        >
          <option value="">Select</option>
          {options.map(option => (
            <option key={option.value} value={option.value}>{option.label}</option>
          ))}
        </select>
      ) : (
        <input
          type={type}
          className={inputClass}
          {...register(name, registerOptions)}
          {...rest}
        />
      )}
      {spanText && <span style={spanStyle}>{spanText}</span>}
      {errors[name] && <span className="text-danger">{errors[name].message}</span>}
    </div>
  );
};

export default FormInput;
